import { modelName } from './constants';
export const getAllList = (state) => state[modelName].allList;
